import { defineStore } from 'pinia'
import { ref } from 'vue'
import type { Ref } from 'vue'

/**
 * Minimal auth store retained as a bridge for gRPC metadata.
 * The XState auth machine (src/machines/auth.machine.ts) is the source of
 * truth for authentication state. This store only holds the Turnstile token
 * because cmw.service.ts reads it for gRPC request metadata headers.
 */
export const useAuthStore = defineStore('auth', () => {
  // Cloudflare Turnstile token for bot protection
  // Set during login, passed to backend via gRPC metadata
  const turnstileToken: Ref<string | null> = ref(null)

  function setTurnstileToken(token: string | null): void {
    turnstileToken.value = token
  }

  function clearTurnstileToken(): void {
    turnstileToken.value = null
  }

  return {
    turnstileToken,
    setTurnstileToken,
    clearTurnstileToken,
  }
})
